var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-cy":"day-header"}},[_c('h4',{staticClass:"uppercase bold"},[_vm._v(_vm._s(_vm.toWeekDay(_vm.dayISO)))]),_c('span',[_vm._v(_vm._s(_vm.toHeaderFormat(_vm.dayISO)))])])}
var staticRenderFns = []

export { render, staticRenderFns }